<template>
  <router-link v-if="lang === 'fr'" :to="{path: markerdata.url}" :tag="'button'">
      <div class="label">
        <slot></slot>
      </div>
  </router-link>

  <router-link v-else-if="lang === 'en'" :to="{path: '/en'+markerdata.url}" :tag="'button'">
      <div class="label">
        <slot></slot>
      </div>
  </router-link>


</template>

<script>

export default {
  props: {
    markerdata: true,
    map: true,
    lang: true
  },
  computed: {
    coordinates() { 
        if (this.markerdata.location) {
          return [JSON.parse(this.markerdata.location).long, JSON.parse(this.markerdata.location).lat]
        }else {
          //paris si pas de coordonnées
          return [2.360042111849225, 48.87994162321]
        }
    }
  },
  methods: {
    popupClicked() {
      alert('Popup Clicked!');
    },
  },
  mounted() {
    new mapboxgl.Marker(this.$el).setLngLat(this.coordinates).addTo(global.map);
  },
  watch: {
    mapIsReady (val) {
      console.log(val)
    },
    $route () {
      if (app.$route.path.split('/')[1] == 'en'){
        this.lang = 'en'
        this.getNavigation()
        this.getSideNavigation()
      }else{
        this.lang = 'fr'
        this.getNavigation()
        this.getSideNavigation()       
      }
      this.lang = global.lang
    }

  }
}
</script>

<style>
.mapboxgl-marker {
  transition-delay: 0ms !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Map/MapMarker.vue